import React, { Component } from 'react';
import { connect } from 'react-redux'; // to connect to redux store from containers redux.js or any other redux store
import HeaderWithTabs from 'components/HeaderWithTabs';
import Session from 'components/Session';
import renderIf from 'render-if';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { ViewAthlete, CoachDashboard } from 'routes/routeNames';
import Loader from 'components/FullScreenLoader';
import StudentView from './components/StudentView';
import CollegeView from './components/CollegeView';
import CoachView from './components/CoachView';
import { SearchUser, SearchAtheleteByName, searchEsUserData,
   getCoachApplications, upgradeCoachApplication, addCoach, searchEsUserRequested,
  resetValues, upgradeStudent, overrideStudent, evaluateStudent, getCoachesFromColleges,
  deleteCoach, modifyCollege, addCollegeToDB, getStudentForStudentExplorer, resetStudentDashboard,
  deleteCoachApplication, esError } from './actions';
import { selector } from './redux';
import styles from './Admin.scss';

class Admin extends Component {
  static propTypes = {
    history: PropTypes.shape.isRequired,
    isLoading: PropTypes.bool.isRequired,
    attributes: PropTypes.shape.isRequired,
    resetValues: PropTypes.func.isRequired,
    coachDeleted: PropTypes.bool.isRequired, // eslint-disable-line
    deleteCoachApplication: PropTypes.func.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      tab: 0,
      coachInfo: {},
      innerTab: 0,
      studentInfo: {},
    };
  }

  componentWillMount() {
    const { attributes, history } = this.props;
    if (attributes.size > 0) {
      if (attributes.get('zoneinfo') !== 'ADMIN') {
        history.goBack();
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    const { attributes, history } = nextProps;
    if (attributes.size > 0) {
      if (attributes.get('zoneinfo') !== 'ADMIN') {
        history.goBack();
      }
    }
    if (nextProps.coachDeleted === true) {
      this.setState({ coachInfo: {} });
    }
  }

  setTabToInitial = () => {
    this.setState({ innerTab: 0 });
  };

  tabListener = (tab) => {
    this.setState({ tab });
    this.innerTabListener(0);
  };

  innerTabListener = (innerTab) => {
    this.setState({ innerTab });
  };

  catchUserInfo = (name, info) => {
    if (name === 'studentInfo') this.props.resetValues('RESET_STUDENT_VALUES');
    this.setState({ [name]: info });
  };

  redirectUser = () => {
    this.props.history.push(this.state.tab === 0 ? ViewAthlete : CoachDashboard);
  };

  // redirectAthelete = () => {
  //   this.props.history.push(ViewAthlete);
  // };

  deleteCoachApplication = (item) => {
    this.props.deleteCoachApplication(item.id);
  }
  render() {
    const { innerTab, studentInfo, coachInfo, tab, coachData } = this.state;
    const renderLoader = renderIf(this.props.isLoading);
    const renderStudentView = renderIf(tab === 0);
    const renderCoachView = renderIf(tab === 1);
    const renderCollegeView = renderIf(tab === 2);
    return (
      <div className={cn('row', styles.container)}>
        {renderLoader(<Loader />)}
        <HeaderWithTabs {...this.props} tab={tab} tabListener={this.tabListener} />
        {renderStudentView(
          <StudentView
            tab={innerTab}
            tabListener={this.innerTabListener}
            userInfo={studentInfo}
            catchUserInfo={this.catchUserInfo}
            setTabToInitial={this.setTabToInitial}
            redirectUser={this.redirectUser}
            // redirectAthelete={this.redirectAthelete}
            {...this.props}
          />)}
        {renderCoachView(
          <CoachView
            tab={innerTab}
            tabListener={this.innerTabListener}
            userInfo={coachInfo}
            catchUserInfo={this.catchUserInfo}
            redirectUser={this.redirectUser}
            {...this.props}
          />)}
        {renderCollegeView(
          <CollegeView
            tab={innerTab}
            tabListener={this.innerTabListener}
            coachData={coachData}
            {...this.props}
          />)}
      </div>
    );
  }
}


export default connect(selector,
  { SearchUser,
    // SearchUserByFullName,
    // SearchStudentByFullName,
    SearchAtheleteByName,
    esError,
    searchEsUserRequested,
    searchEsUserData,
    getCoachApplications,
    upgradeStudent,
    overrideStudent,
    evaluateStudent,
    deleteCoach,
    addCoach,
    modifyCollege,
    resetValues,
    getCoachesFromColleges,
    addCollegeToDB,
    getStudentForStudentExplorer,
    deleteCoachApplication,
    resetStudentDashboard,
    upgradeCoachApplication })(Session(Admin));



// WEBPACK FOOTER //
// ./src/containers/Admin/Admin.js